module.exports = __webpack_public_path__ + "img/tab-icon5.938d52cc.png";